import { getGlobalThis } from './globalThis';

export {};

const global: typeof globalThis = getGlobalThis();

if (typeof global.queueMicrotask !== 'function') {
  global.queueMicrotask = function (callback: VoidFunction | (() => void)) {
    Promise.resolve()
      .then(callback)
      .catch((e) =>
        setTimeout(() => {
          throw e;
        }),
      );
  };
}
